import { render, staticRenderFns } from "./addEvent.vue?vue&type=template&id=aaba2a74&scoped=true&"
import script from "./addEvent.vue?vue&type=script&lang=js&"
export * from "./addEvent.vue?vue&type=script&lang=js&"
import style0 from "./addEvent.vue?vue&type=style&index=0&id=aaba2a74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaba2a74",
  null
  
)

export default component.exports